import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const navbarSelector = `.${manifest.blockJsClass}`;
	const navbarToggleSelector = `${navbarSelector}-toggle`;
	const navbarWrapperSelector = `${navbarSelector}-wrapper`;

	const navbarElements = document.querySelectorAll(navbarSelector);

	const { NavbarToggle } = await import('./navbar-toggle');

	navbarElements.forEach((item) => {
		new NavbarToggle({
			navbar: item,
			navbarToggleSelector: navbarToggleSelector,
			navbarWrapperSelector: navbarWrapperSelector,
		}).init();
	});
});
